import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import {
  box,
  flexContainer,
  flexItem,
  basePosition,
  boxShadow,
  backgroundImage
} from '../../themes/Mixins'
import METRICS from '../../themes/Metrics'

export const Box = styled.div `
  ${props => box(
    props.width || '',
    props.height || '',
    props.bgColor || 'inherit'
  )};

  padding: ${props => props.padding || METRICS.basePadding};
  margin: ${props => props.margin || `${METRICS.baseMargin} 0`};
  border: ${props => props.border || ''};
  border-bottom: ${props => props.borderBottom || ''};
  border-radius: ${props => props.borderRadius || METRICS.baseBorderRadius};
  position:  ${props => props.position || ''};
  z-index:  ${props => props.zIndex || '1'};
  min-height:  ${props => props.minHeight || ''};
  color:  ${props => props.color || 'inherit'};
  text-align: ${props => props.textAlign || 'left'};
  overflow: ${props => props.overflow || ''};

  ${props => props.position === 'absolute' && basePosition(
    props.basePosition.top || '0',
    props.basePosition.left || '0',
    props.basePosition.right || '0',
    props.basePosition.bottom || '0'
  )};

  ${props => css`${props.customStyle}`};
`

export const FlexBox = Box.extend`
  ${props => flexContainer(
    props.alignItems || '',
    props.justifyContent || '',
    props.flexWrap || '',
    props.flexDirection || ''
  )};
`

export const FlexItem = Box.extend`
  ${props => flexItem(
    props.align || '',
    props.flexGrow || '',
    props.order || ''
  )}
`

export const BoxShadow = FlexBox.extend`
  ${props => boxShadow(
    props.value || ''
  )}
`

export const BoxImage = Box.extend`
  ${props => backgroundImage(
    props.bgImage || '',
    props.bgRepeat || '',
    props.bgPosition || '',
    props.bgSize || ''
  )}
`

// Defined Props Types
Box.propTypes = {
  basePosition: PropTypes.object
}

// Defined default Props
Box.defaultProps = {
  basePosition: {}
}



// WEBPACK FOOTER //
// ./src/components/common/Box.js